import { render, staticRenderFns } from "./HeroPage.vue?vue&type=template&id=566a3d61&scoped=true&"
import script from "./HeroPage.vue?vue&type=script&lang=js&"
export * from "./HeroPage.vue?vue&type=script&lang=js&"
import style0 from "./HeroPage.vue?vue&type=style&index=0&id=566a3d61&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566a3d61",
  null
  
)

export default component.exports